class AANTabNav {
	init(): void {
		const tabNavs: HTMLElement[] = Array.from(document.querySelectorAll(".tab-nav"));

		tabNavs.forEach(tabNav => {
			const menuLabel: HTMLLabelElement | null = tabNav.querySelector(".dropdown-menu-label");
			menuLabel?.addEventListener("click", () => {
				if (menuLabel.classList.contains("show")) {
					menuLabel.classList.remove("show");
				} else {
					menuLabel.classList.add("show");
				}
			});

			const activeTab: HTMLLIElement | null = tabNav.querySelector(".active");
			const tabMenu = tabNav.querySelector("ul");

			if (!activeTab || !tabMenu) {
				return;
			}

			tabMenu.scrollLeft = activeTab.offsetLeft - (parseInt(getComputedStyle(activeTab).width) / 2);
		});

		if (tabNavs && tabNavs.length > 0) {
			// If the user clicks outside of the nav menu stop showing all the nav menu items.
			document.addEventListener("click", event => {
				const anyTabMenusDisplaying = Array.from(document.querySelectorAll(".tab-nav .dropdown-menu-label.show")).length > 0;
				// If we don't have a tab menu being displayed, don't run the other logic as it is unnecessary work.
				if (!anyTabMenusDisplaying) {
					return;
				}

				// If we are clicking in a tab menu, don't run the logic to close the tab menu.
				if (tabNavs.some(tabNav => tabNav === event.target || tabNav.contains(event.target as HTMLElement))) {
					return;
				}
				tabNavs.forEach(tabNav => {
					tabNav.querySelector(".dropdown-menu-label")?.classList.remove("show");
				});
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const tabNav = new AANTabNav();

	tabNav.init();
});
